import React, { Component, Fragment } from 'react';
import "../style/WhoWeAre.scss";
import NavbarComponent from '../../../landing/shared/navbar/components/NavbarComponent';
import FooterComponent from "../../../shared/footer/components/FooterComponent";
import LightBoxComponent from "../../../shared/lightbox/components/LightBoxComponent";
import RegisterModalComponent from "../../../shared/registermodal/components/RegisterModalComponent";
import LoginComponent from "../../../shared/Login/components/LoginComponent";
import axios from "axios";
import LoadingComponent from "../../../shared/loading/components/LoadingComponent";
import ScrollableAnchor, {configureAnchors} from 'react-scrollable-anchor'
import isMobile from 'is-mobile'
import SlideComponent from "../../../landing/shared/slide/components/slideComponent";

class WhoWeAre extends Component {
  constructor(props) {
    super(props);
    this.state = {
        whoWeAre: [],
        showLogin: false,
        showRegister: false,
        loading: true
    };
    this.closeRegister = this.closeRegister.bind(this);
    this.openRegister = this.openRegister.bind(this);
    this.openLogin = this.openLogin.bind(this);
    this.closeLogin = this.closeLogin.bind(this);

  }

    async getWhoWeAre() {
        let result = await axios.get(`api/who-we-are/`);
        let response = await result.data;

        this.setState({
            whoWeAre: response,
            loading: false
        })
    }
    openLogin() {
        this.setState({
            showLogin: true
        });
    }

    closeLogin() {
        this.setState({
            showLogin: false
        });
    }

    openRegister(companyType = '') {
        this.setState({
            registerCompanyType: companyType,
            showRegister: true
        });
    }

    closeRegister() {
        this.setState({
            showRegister: false
        })
    }

    componentDidMount() {
        this.getWhoWeAre();
    }
    componentWillMount() {
        configureAnchors({
            offset: -120, scrollDuration: 1000
        });
    }

    render() {

        if(this.state.loading) {
            return <LoadingComponent />
        }

        const banner = this.state.whoWeAre.whoweare.banner ? this.state.whoWeAre.whoweare.banner : `${process.env.PUBLIC_URL}/images/whoweare/team.png`;
        
        let team_content = (this.state.whoWeAre.members.map( (member, index) => {
            return (
                <div className="portrait" key={index}>
                    <img
                        src={member.image}
                        className="portraitImage"
                        alt={member.name}
                    />

                    <div className="card">
                        <div className="cardHeader">
                            <h2>{ member.nickname }</h2>
                            <h3>{ member.office }</h3>
                            <div className="borderCard" />
                        </div>
                        <div className="cardContent">
                            <p>
                                { member.description }
                            </p>
                        </div>
                        <div className="cardFooter">
                            <h3>{ member.name }</h3>
                        </div>
                    </div>
                </div>
            )
        })
        )
        if (isMobile()) {
            team_content = (
                <SlideComponent
                        dots={true}
                        infinite={true}
                        speed={500}
                        slidetoshow={2}
                        slideScroll={2}
                        slidesPerRow={1}
                        initialSlide={0}
                        extraSettings={{autoplay: true}}
                    >
                        {team_content}
                    </SlideComponent>
            )
        }
        
        return(
            <Fragment>
                <NavbarComponent showLogin={() => this.openLogin()}/>
                {this.state.showRegister &&
                  <RegisterModalComponent companyType={this.state.registerCompanyType} close={this.closeRegister}/>
                }

                {this.state.showLogin &&
                <LightBoxComponent isOpen={this.state.showLogin} handleClick={() => this.closeLogin()}
                                   handleEventClose={() => this.closeLogin()}
                >
                    <LoginComponent
                    closeRegister={this.closeRegister}
                    OpenRegister={this.openRegister.bind(this)}/>
                </LightBoxComponent>
                }
                <section id="Wrapper">
                    <div
                        className="teamHighLight"
                        style={{ backgroundImage: `url(${banner})` }}
                    >
                        <h1 className="wrapperText">
                            { this.state.whoWeAre.whoweare.title }
                        </h1>
                    </div>
                </section>

                <div className="whoWeAreContainer">

                    <div className="separator"/>

                    <section id="OurTeam">
                        <ScrollableAnchor id='ourteam'>
                          <h3 className="title">{ this.state.whoWeAre.whoweare.our_team_title }</h3>
                        </ScrollableAnchor>
                        <p className="descriptionText">
                            { this.state.whoWeAre.whoweare.our_team_text }
                        </p>
                    </section>
                    <section className="portraits">
                        <div className="portrait-content">
                            {team_content}

                        </div>
                    </section>

                    <div className="separator"/>

                    <section id="OurPartners">
                        <h3 className="title">{ this.state.whoWeAre.whoweare.our_partners_title }</h3>
                        <p className="descriptionText">
                            { this.state.whoWeAre.whoweare.our_partners_text }
                        </p>
                    </section>

                    <div className="partnersContainer">
                        {this.state.whoWeAre.partners.map( (partner, index) => {
                            return (
                                <div className="partner" key={index}><img src={partner.image} alt={partner.name} /></div>
                            )
                        })}
                    </div>

                </div>
                <FooterComponent />
            </Fragment>
        );
    };
};

export default WhoWeAre;
